module.exports = __webpack_public_path__ + "static/android_paso_1-b717003494120d89a40415764d2857e9.png";